/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseEnrollmentDocuments200,
  GetApiV1DocumentCourseEnrollmentDocuments401,
  GetApiV1DocumentCourseEnrollmentDocuments500,
  GetApiV1DocumentCourseEnrollmentDocumentsQueryParams,
  GetApiV1DocumentCourseEnrollmentDocumentsQueryResponse,
} from "../../types/documentCourseController/GetApiV1DocumentCourseEnrollmentDocuments.ts";
import { enrollmentDocumentManagementRepositoryResponseSchema } from "../enrollmentDocumentManagementRepositoryResponseSchema.ts";

export const getApiV1DocumentCourseEnrollmentDocumentsQueryParamsSchema =
  z.object({
    courseId: z.optional(z.coerce.number().int()),
    pageNumber: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseEnrollmentDocuments200Schema = z.array(
  z.lazy(() => enrollmentDocumentManagementRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocuments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseEnrollmentDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocuments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseEnrollmentDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocuments500>;

export const getApiV1DocumentCourseEnrollmentDocumentsQueryResponseSchema =
  z.lazy(
    () => getApiV1DocumentCourseEnrollmentDocuments200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseEnrollmentDocumentsQueryResponse>;
